import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { ValueChapca } from "../models/ValueChapca";
import { ReferentialEntity } from "../models/referential-entity";

@Injectable()
export class ReferentialService {
  /**
   * Load dependencies
   * @param {ApiService} apiService
   */
  constructor(private apiService: ApiService) {}

  searchReferential(
    referentialTypeId: string,
    languageId: number,
    nonSport: boolean,
    selectedReferentialEntities: ReferentialEntity[]
  ) {
    const url =
      "Referential/Search?referentialTypeId=" +
      referentialTypeId +
      "&languageId=" +
      languageId +
      "&nonSport=" +
      nonSport;
    return this.apiService.post(url, selectedReferentialEntities).map((res) => {
      if (res && res.values) {
        return res.values.map((item) => new ReferentialEntity(item));
      }
    });
  }

  /**
   * Fetch all channelGroup from the API
   * @returns {Observable<any>}
   */
  getChannelGroup() {
    return this.apiService.get("Referential/ChannelGroups").map((res) => {
      if (res && res.values) {
        return res.values.map((item) => new ValueChapca(item));
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/referential.service.ts